import { useAuth } from '../auth/AuthContext';
import Icon from '../components/Icon';

function greeting() {
  const h = new Date().getHours();
  return h < 12 ? 'Good morning' : h < 18 ? 'Good afternoon' : 'Good evening';
}

export default function Dashboard() {
  const { user, permissions, isSuperAdmin, can } = useAuth();
  const firstName = (user?.name || '').split(' ')[0];

  const groups = new Set(permissions.map((p) => p.split('.')[0]));

  return (
    <div>
      <section className="hero">
        <h2>
          {greeting()}, {firstName || 'there'} 👋
        </h2>
        <p>
          Welcome to aptcrm. Open <strong>Leads</strong> from the menu to register leads and log follow-ups.
        </p>
      </section>

      <div className="stat-grid">
        <div className="stat">
          <div className="stat-icon">
            <Icon name="shield" size={22} />
          </div>
          <div>
            <div className="label">Access level</div>
            <div className="value">{isSuperAdmin ? 'Super admin' : 'Admin'}</div>
          </div>
        </div>
        <div className="stat">
          <div className="stat-icon ok">
            <Icon name="key" size={22} />
          </div>
          <div>
            <div className="label">Permissions</div>
            <div className="value">{isSuperAdmin ? 'All' : permissions.length}</div>
          </div>
        </div>
        <div className="stat">
          <div className="stat-icon">
            <Icon name="dashboard" size={22} />
          </div>
          <div>
            <div className="label">Feature areas</div>
            <div className="value">{isSuperAdmin ? 'All' : groups.size}</div>
          </div>
        </div>
        {can('admins.view') && (
          <div className="stat">
            <div className="stat-icon ok">
              <Icon name="users" size={22} />
            </div>
            <div>
              <div className="label">Admin management</div>
              <div className="value">Enabled</div>
            </div>
          </div>
        )}
      </div>

      <div className="card">
        <div className="card-head">
          <h2>Your access</h2>
        </div>
        <div className="card-body">
          {isSuperAdmin ? (
            <span className="badge">super-admin — full access</span>
          ) : permissions.length ? (
            permissions.map((p) => (
              <span key={p} className="badge">
                {p}
              </span>
            ))
          ) : (
            <span className="badge badge-plain">no permissions assigned</span>
          )}
        </div>
      </div>
    </div>
  );
}
